import PropTypes from 'prop-types'
import React from 'react'
import MainLayout from 'layouts/MainLayout'
import { useFaqNavItems } from 'modules/Faq/hooks/useFaqNavItems'
import styles from 'modules/Faq/styles/Faq.module.scss'

const FaqMainLayout = ({ children = null }) => {
  const { items, loading } = useFaqNavItems(true)

  return (
    <MainLayout
      className={styles['faq-main-layout']}
      navItems={items}
      navLoading={loading}
      hasBalance={false}
      isFooterCompact={true}
    >
      {children}
    </MainLayout>
  )
}

FaqMainLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
}

export default FaqMainLayout
